import { render } from "./MainTypeOfVouchers.vue?vue&type=template&id=72c576ec&scoped=true"
import script from "./MainTypeOfVouchers.vue?vue&type=script&lang=js"
export * from "./MainTypeOfVouchers.vue?vue&type=script&lang=js"

import "./MainTypeOfVouchers.vue?vue&type=style&index=0&id=72c576ec&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c576ec"]])

export default __exports__